import React from "react";
import get from "lodash/get";
import "./video-card.m.css";
import PlayButton from "../../../../assets/icons/playButton";

import PlusIcon from "../../atoms/PlusIcon";
import MinusIcon from "../../atoms/MinusIcon";

export const VideoCard = ({ item, isTextView, onToggle, onPlayVideo }) => {
    const toggleView = (e) => {
        e.stopPropagation();
        if (onToggle) {
            onToggle(item.id);
        }
    };

    const hasHeader = item.category || item.date;
    const hasContent = item.title || item.speakerName || item.speakerPosition;

    return (
        <div styleName="card-wrapper">
            {hasHeader && (
                <div styleName="card-header">
                    <span styleName="category">{item.category}</span>
                    {item.category && item.date && <span styleName="divider">|</span>}
                    <span styleName="date">{item.date}</span>
                </div>
            )}
            
            {isTextView ? (
                <div styleName="text-card">
                    <div styleName="text-content">
                        <div
                            styleName="video-description"
                            dangerouslySetInnerHTML={{ __html: item.videoDesc }}
                        />
                    </div>
                    <div styleName="toggle-button minus-button" onClick={toggleView}>
                        <MinusIcon />
                    </div>
                </div>
            ) : (
                <div styleName={`video-card ${item.videoDesc ? 'show-black-border' : ''} ${!hasContent ? 'full-width-thumbnail' : ''}`}>
                    <div styleName="video-image">
                        <img
                            src={item.videoThumbnail}
                            alt={item.title}
                            styleName="thumbnail-image"
                        />
                    </div>
                    <div styleName="play-button" onClick={() => onPlayVideo(item.videoEmbed)}>
                        <PlayButton />
                    </div>
                    {item.videoDesc && (
                        <div styleName="toggle-button plus-button" onClick={toggleView}>
                            <PlusIcon />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};
